import makeStyles from '@material-ui/core/styles/makeStyles';

const useCommonStyles = makeStyles(theme => ({
  backgroundImage: {
    position: 'relative',
    '&::before': {
      background: 'url(/images/background-images/dots.svg)',
      content: '""',
      position: 'absolute',
      zIndex: '-1',
      transform: 'rotate(-27.66deg)',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
      opacity: 0.04,
      width: 195.62,
      height: 124.69,
      top: -27,
      left: 0,
      [theme.breakpoints.up('sm')]: {
        width: 302.51,
        height: 192.82,
        top: 15,
        left: '-15%'
      }
    }
  },
  colorPrimary: {
    color: theme.palette.primary.main
  },
  marginHorizontal2UpSm: {
    margin: theme.spacing(0, 2),
    [theme.breakpoints.up('sm')]: {
      margin: 0
    }
  },
  'marginBottom-5': {
    marginBottom: theme.spacing(5)
  }
}));

export { useCommonStyles as default, useCommonStyles };
